import { Search, X } from 'lucide-react'
import styles from './SearchInput.module.css'

type Props = {
	value: string
	onChange: (next: string) => void
	placeholder?: string
}

// Reusable clearable search field: leading icon, trailing clear button.
// Controlled — the caller owns the query string and reacts to it live.
export const SearchInput = ({ value, onChange, placeholder }: Props) => (
	<div className={styles.wrap}>
		<Search className={styles.icon} size={18} aria-hidden="true" />
		<input
			type="search"
			className={styles.input}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			placeholder={placeholder}
			autoComplete="off"
			autoCapitalize="none"
			autoCorrect="off"
			spellCheck={false}
		/>
		{value !== '' ? (
			<button
				type="button"
				className={styles.clear}
				aria-label="Clear search"
				onClick={() => onChange('')}
			>
				<X size={16} aria-hidden="true" />
			</button>
		) : null}
	</div>
)
